import {HttpService} from "./api/HttpService";

class MapOverlayService {

    fetchMapOverlay = (mapOverlayId) => {
        return new Promise((resolve, reject) => {
            HttpService.create().get(`/mapoverlay/mapOverlay/${mapOverlayId}`)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    };

    get getMapOverlays () {
        return new Promise((resolve, reject) => {
            HttpService.create().get('/mapoverlay/mapOverlays')
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

}
const mapOverlayService = new MapOverlayService();
export default mapOverlayService;